"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sdk_1 = require("@cosmwasm/sdk");
const bcp_1 = require("@iov/bcp");
const encoding_1 = require("@iov/encoding");
const bn_js_1 = __importDefault(require("bn.js"));
const { fromBase64 } = encoding_1.Encoding;
function decodePubkey(pubkey) {
    switch (pubkey.type) {
        case sdk_1.types.pubkeyType.secp256k1:
            return {
                algo: bcp_1.Algorithm.Secp256k1,
                data: fromBase64(pubkey.value),
            };
        case sdk_1.types.pubkeyType.ed25519:
            return {
                algo: bcp_1.Algorithm.Ed25519,
                data: fromBase64(pubkey.value),
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
exports.decodePubkey = decodePubkey;
function decodeSignature(signature) {
    return fromBase64(signature);
}
exports.decodeSignature = decodeSignature;
function decodeFullSignature(signature, nonce) {
    return {
        nonce: nonce,
        pubkey: decodePubkey(signature.pub_key),
        signature: decodeSignature(signature.signature),
    };
}
exports.decodeFullSignature = decodeFullSignature;
function coinToDecimal(tokens, coin) {
    const match = tokens.find(({ denom }) => denom === coin.denom);
    if (!match) {
        throw Error(`unknown denom: ${coin.denom}`);
    }
    const value = encoding_1.Decimal.fromAtomics(coin.amount, match.fractionalDigits);
    return [value, match.ticker];
}
exports.coinToDecimal = coinToDecimal;
function decodeAmount(tokens, coin) {
    const [value, ticker] = coinToDecimal(tokens, coin);
    return {
        quantity: value.atomics,
        fractionalDigits: value.fractionalDigits,
        tokenTicker: ticker,
    };
}
exports.decodeAmount = decodeAmount;
function parseMsg(msg, memo, chainId, tokens, erc20Tokens) {
    var _a, _b;
    if (sdk_1.types.isMsgSend(msg)) {
        if (msg.value.amount.length !== 1) {
            throw new Error("Only MsgSend with one amount is supported");
        }
        const send = {
            kind: "bcp/send",
            chainId: chainId,
            sender: msg.value.from_address,
            recipient: msg.value.to_address,
            amount: decodeAmount(tokens, msg.value.amount[0]),
            memo: memo,
        };
        return send;
    }
    else if (sdk_1.types.isMsgExecuteContract(msg)) {
        const matchingTokenContract = erc20Tokens.find((t) => t.contractAddress === msg.value.contract);
        if (!matchingTokenContract) {
            return {
                chainId: chainId,
                kind: "bcp/unknown",
            };
        }
        const recipient = (_a = msg.value.msg.transfer) === null || _a === void 0 ? void 0 : _a.recipient;
        if (!recipient)
            throw new Error("Could not read recipient");
        const amount = (_b = msg.value.msg.transfer) === null || _b === void 0 ? void 0 : _b.amount;
        if (!amount)
            throw new Error("Could not read recipient");
        const send = {
            kind: "bcp/send",
            chainId: chainId,
            sender: msg.value.sender,
            recipient: recipient,
            amount: {
                quantity: new bn_js_1.default(amount).toString(),
                fractionalDigits: matchingTokenContract.fractionalDigits,
                tokenTicker: matchingTokenContract.ticker,
            },
            memo: memo,
        };
        return send;
    }
    else {
        // Unknown transaction type
        const unknown = {
            chainId: chainId,
            kind: "bcp/unknown",
        };
        return unknown;
    }
}
exports.parseMsg = parseMsg;
function parseFee(fee, tokens) {
    if (fee.amount.length !== 1) {
        throw new Error("Only fee with one amount is supported");
    }
    return {
        tokens: decodeAmount(tokens, fee.amount[0]),
        gasLimit: fee.gas,
    };
}
exports.parseFee = parseFee;
function parseUnsignedTx(txValue, chainId, tokens, erc20Tokens) {
    if (!sdk_1.types.isStdTx(txValue)) {
        throw new Error("Only StdTx is supported");
    }
    if (txValue.msg.length !== 1) {
        throw new Error("Only single-message transactions currently supported");
    }
    const msg = parseMsg(txValue.msg[0], txValue.memo, chainId, tokens, erc20Tokens);
    const fee = parseFee(txValue.fee, tokens);
    return Object.assign(Object.assign({}, msg), { chainId: chainId, fee: fee });
}
exports.parseUnsignedTx = parseUnsignedTx;
function parseSignedTx(txValue, chainId, nonce, tokens, erc20Tokens) {
    const [primarySignature] = txValue.signatures.map((signature) => decodeFullSignature(signature, nonce));
    return {
        transaction: parseUnsignedTx(txValue, chainId, tokens, erc20Tokens),
        signatures: [primarySignature],
    };
}
exports.parseSignedTx = parseSignedTx;
function parseTxsResponseUnsigned(chainId, currentHeight, response, tokens, erc20Tokens) {
    return {
        transaction: parseUnsignedTx(response.tx.value, chainId, tokens, erc20Tokens),
        height: response.height,
        confirmations: currentHeight - response.height + 1,
        transactionId: response.hash,
        log: response.rawLog,
    };
}
exports.parseTxsResponseUnsigned = parseTxsResponseUnsigned;
function parseTxsResponseSigned(chainId, currentHeight, nonce, response, tokens, erc20Tokens) {
    return Object.assign(Object.assign({}, parseSignedTx(response.tx.value, chainId, nonce, tokens, erc20Tokens)), { height: response.height, confirmations: currentHeight - response.height + 1, transactionId: response.hash, log: response.rawLog });
}
exports.parseTxsResponseSigned = parseTxsResponseSigned;
//# sourceMappingURL=decode.js.map